import $ from 'jquery';
import { getState, getStatePure } from '~src/state';

import { getAxiosClient } from '~src/api';
import { modifyState } from '~src/state';
import { onErrorShowMessage } from '~src/errors';
import Swal from 'sweetalert2';
import { saveEditorState } from '~core';
import { showVideoPreview } from '~video';
import {
  EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER,
  EDITOR_MODE_ORG_TEMPLATE_MANAGER,
} from '~config/editorConstants';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const generateVideo = async ({ isPreview = false }) => {
  let fps = 30;
  let multiplier = 1;

  if (isPreview) {
    fps = 15;
    multiplier = 1;
  }

  const shouldBeSavedFirst = getState('totalChangesSinceLastSave', 0) > 0;

  const secondMessage = 'Video in attesa di essere processato...';
  let initialMessage = shouldBeSavedFirst
    ? 'Sto salvando il progetto...'
    : secondMessage;

  Swal.fire({
    html: `<div><p class="lead" id="video-progress-text">${initialMessage}</p>
      <div id="giotto-video-progress-bar-container" class="progress" style="display: none;">
        <div id="giotto-video-progress-bar" class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 0%"></div>
      </div>
    </div>`,
    confirmButtonColor: '#278e8e',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  if (shouldBeSavedFirst) {
    await saveEditorState(true, true);
  }

  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');
  const httpClient = await getAxiosClient();
  const httpClientWithRetries = await getAxiosClient(true, 30);

  const { width, height } = window.canvas;

  const animations =
    typeof pages[currentPageIndex].animations === 'string'
      ? JSON.parse(pages[currentPageIndex].animations)
      : pages[currentPageIndex].animations;

  const payload = {
    rendering: {
      width,
      height,
      fps,
      multiplier,
    },
    encoding: {
      fps: {
        input: fps,
        output: fps,
      },
    },
    animations,
  };

  if (EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER === getState('editorMode')) {
    payload.templateDefaultPageId = pages[currentPageIndex].objectId;
  } else if (EDITOR_MODE_ORG_TEMPLATE_MANAGER === getState('editorMode')) {
    payload.templatePageId = pages[currentPageIndex].objectId;
  } else {
    payload.canvasPageId = pages[currentPageIndex].objectId;
  }

  if (getState('soundtrackId')) {
    payload.encoding.soundtrack = getState('soundtrackId');
  }

  const videoDuration = pages[currentPageIndex].animations.reduce(
    (acc, animation) => {
      acc += animation.fromProps?.duration ?? 0;
      acc += animation.toProps?.duration ?? 0;
      return acc;
    },
    0
  );

  if (getState('backgroundVideoId')) {
    payload.encoding.backgroundVideo = {
      videoPath: getState('backgroundVideoId'),
      inSeconds: 0,
      outSeconds: videoDuration,
    };
    payload.rendering.multiplier = 1;
  }

  $('#video-progress-text').text(secondMessage);
  $('#giotto-video-progress-bar-container').fadeIn();

  try {
    const response = await httpClient.post(
      `${process.env.GIOTTO_API_URL}/videos`,
      payload
    );

    modifyState('giottoVideoId', response.data.videoId);

    let isComplete = false;
    let getProgressResponse;
    while (!isComplete) {
      await sleep(1000);

      getProgressResponse = await httpClientWithRetries.get(
        `${process.env.GIOTTO_API_URL}/videos/${response.data.videoId}`
      );

      if (getProgressResponse.data.video) {
        isComplete = true;
      } else if (getProgressResponse.data.progress) {
        $('#giotto-video-progress-bar').css(
          'width',
          `${getProgressResponse.data.progress.progress}%`
        );

        $('#video-progress-text').text(
          getProgressResponse.data.progress.stage === 'rendering'
            ? 'Sto creando il video...'
            : 'Il video è quasi pronto! Un secondo...'
        );
      }
    }

    if (isPreview) {
      Swal.hideLoading();
      Swal.close();

      showVideoPreview(getProgressResponse.data.video.url);
    }

    modifyState('videoPreviewUrl', getProgressResponse.data.video.url);
    return getProgressResponse.data;
  } catch (error) {
    console.error('Error in giotto video generation', error);
    onErrorShowMessage();
  }
};
